import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	ControlValueAccessor,
	UntypedFormControl,
	UntypedFormGroup,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ErrorMessage } from '../../constants/enum.const';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ConfigQuestion } from '../../models/config-question.interface';

@Component({
	selector: 'bcb-generic-checkbox',
	templateUrl: './generic-checkbox.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: GenericCheckboxComponent,
		},
	],
	styleUrls: ['./generic-checkbox.component.scss'],
})
export class GenericCheckboxComponent implements ControlValueAccessor, OnInit {
	@Input() question!: ConfigQuestion;
	@Input() formGroup!: UntypedFormGroup;
	@Input() formControl!: UntypedFormControl;
	@Input() formControlName!: string;
	@Input() errorMessage?: ErrorMessage;
	@Output() change: EventEmitter<any> = new EventEmitter<any>();

	value: any;
	isDisabled: boolean = false;

	constructor() {}

	ngOnInit(): void {
		if (this.formControl) {
			this.formGroup = this.formControl.parent as UntypedFormGroup;
		} else if (this.formGroup && this.formControlName) {
			this.formControl = this.formGroup.get(
				this.formControlName
			) as UntypedFormControl;
		} else {
			throw new Error(
				'One of the following is required: [formControl] or [formControlName] + [FormGroup]'
			);
		}
	}

	changed: (value: any) => void = () => {};

	touched: () => void = () => {};

	writeValue(obj: any): void {
		this.value = obj;
	}

	onChange(event: MatCheckboxChange): void {
		this.change.emit(event.checked);
		this.changed(event.checked);
	}

	registerOnChange(fn: any): void {
		this.changed = fn;
	}

	registerOnTouched(fn: any): void {
		this.touched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
